<template>
    <div class="filter-bar__search" :class="{'filter-bar__search--active': display}">
        <div class="field field--addons">
            <div class="control">
                <input ref="search" class="input" type="search" name="search" placeholder="Search" @keyup.enter="search" v-model="q">
            </div>
            <div class="control" v-if="icon">
                <button class="button"><i class="icon-search" @click="search"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../event-bus";

    export default {
        props: {
            display: {
                type: Boolean,
                default: true
            },
            icon: {
                type: Boolean,
                default: true
            },
            query: String
        },
        data() {
            return {
                q: this.query
            };
        },
        methods: {
            search() {
                EventBus.$emit('search', this.q);
            }
        },
        watch: {
            display(value) {
                if (value) {
                    this.$nextTick(function() {
                        this.$refs.search.focus();
                    });
                }
            }
        }
    };
</script>